import DocumentManager from './DocumentManager'

export default DocumentManager
